import AppAnnouncementCard from './components/AppAnnouncementCard';

const AppAnnouncement = () => {
  return <AppAnnouncementCard />;
};

export default AppAnnouncement;
